// hooks/useSessionUser.ts
import { useCallback } from "react";
import { UserData } from "src/types/user.type";

const USER_SESSION_KEY = "chedmed_user";

export function useSessionUser() {
  const storeUserData = useCallback((user: UserData) => {
    sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify(user));
  }, []);

  const getUserData = useCallback((): UserData | null => {
    const data = sessionStorage.getItem(USER_SESSION_KEY);
    return data ? (JSON.parse(data) as UserData) : null;
  }, []);

  const clearUserData = useCallback(() => {
    sessionStorage.removeItem(USER_SESSION_KEY);
  }, []);

  return {
    storeUserData,
    getUserData,
    clearUserData,
  };
}
